//import { gsap } from 'gsap'
//import { ScrollTrigger } from 'gsap/src/ScrollTrigger'

import cookieConsentFocusTrap from './utilities/cookie-consent-focus-trap.js'
import konamiCode from './utilities/konami-code.js'
import initSelligentPostInterceptor from './utilities/selligent-post-interceptor.js'

import '../../components/atoms/**/*.js'
import '../../components/molecules/**/*.js'
import '../../components/organisms/**/*.js'
import '../../components/structures/**/*.js'

console.log('\n %cMade with %c♥%c by Fabrique \n', 'font: 16px serif;', 'font: 13px serif; color: #f00;', 'font: 16px serif;')

// There are 4 load events:
// - 'init-immediate': (compiles when the script is loaded; blocks rendering)
// - 'init-load': (on DOMContentLoaded event; does not block rendering)
// - 'init-after-load': (on Load event, slightly after DOMContentLoaded)
// - 'init-delayed-load': (after Load event, with a slight delay, for iframes and such)
// Usually, the 'init-load' event will suffice.
window.dispatchEvent(new CustomEvent('init-immediate'))
window.addEventListener('DOMContentLoaded', () => window.dispatchEvent(new CustomEvent('init-load')))
window.addEventListener('load', () => window.dispatchEvent(new CustomEvent('init-after-load')))
window.addEventListener('load', () => window.setTimeout(() => window.dispatchEvent(new CustomEvent('init-delayed-load')), 1000))

// Focus stuff
document.addEventListener('keydown', () => document.documentElement.classList.add('key-pressed'))
document.addEventListener('mousedown', () => document.documentElement.classList.remove('key-pressed'))
document.addEventListener('touchstart', () => document.documentElement.classList.remove('key-pressed'))

cookieConsentFocusTrap()
konamiCode()
window.addEventListener('init-load', () => initSelligentPostInterceptor())

window.addEventListener('konami', () => {
  if (document.documentElement.classList.contains('konami-code')) {
    document.documentElement.classList.remove('konami-code')
  } else {
    document.documentElement.classList.add('konami-code')
    window.dispatchEvent(new CustomEvent('konami-code'))
  }
})
